import { Link } from "react-router-dom";
import { styled } from "styled-components";
import OFFICE from "../assets/foto/10.jpg";
import WORK1 from "../assets/foto/27.jpg";
import KITCHEN from "../assets/foto/37.jpg";
import DOWN from "../assets/foto/down.png";
import {
  Container,
  FixedArrow,
  Image,
  ImageContainer,
  ListContainer,
  ListItem,
  MainContainer,
  PreText,
  TextList,
} from "../containers/PageContainer";
import { useMenu } from "../hooks/useMenu";
import { useScroll } from "../hooks/useScroll";
import { StyledH1 } from "../StyledComponents";

export const Home: React.FC = () => {
  const { isScrolled } = useScroll();
  const { isMenuClosed } = useMenu();

  return (
    <>
      <Container $isScrolled={isScrolled} $isMenuClosed={isMenuClosed}>
        <StyledH1>Tomáš Frajvald - FAMA - výroba nábytku</StyledH1>
        <PreText>
          <strong>Firma Fama</strong> byla založena v roce <strong>1992</strong>
          . Hlavní činností je výroba zakázkových kuchyní a{" "}
          <strong>atypického nábytku</strong> dle přání i&nbsp;toho
          nejnáročnějšího zákazníka.
        </PreText>
        <MainContainer>
          <ListContainer $isScrolled={isScrolled}>
            <TextList>
              <ListItem>
                <strong>Zakázková výroba</strong> - Kuchyně, obývací pokoje,
                ložnice, dětské pokoje, kanceláře a&nbsp;další.
              </ListItem>
              <ListItem>
                <strong>Komplexní služby</strong> - Výrobu zajišťujeme vlastními
                výrobními kapacitami včetně dopravy a&nbsp;montáže.
              </ListItem>
              <ListItem>
                <strong>Kontakt</strong> - Neváhejte nás{" "}
                <NavLink to="/contact">kontaktovat</NavLink> pro&nbsp;více
                informací nebo konzultaci.
              </ListItem>
            </TextList>
          </ListContainer>
          <ImageContainer $isScrolled={isScrolled}>
            <Image src={KITCHEN} alt="práce" />
            <Image src={WORK1} alt="práce" />
            <Image src={OFFICE} alt="práce" />
          </ImageContainer>
        </MainContainer>
      </Container>
      <FixedArrow src={DOWN} alt="Down Arrow" $isScrolled={isScrolled} />
    </>
  );
};

const NavLink = styled(Link)`
  color: rgb(52 181 75);
  text-decoration: none;
  &:hover {
    color: #5e8f20;
  }
`;
